/**
 * Does not rely on a call to I18n, so it can be called asynchronously
 * @param product
 * @param localeProperties
 */
export function useGetProductPathAsync(
  product: {
    id: string
    extensions?: { novuSeoUrls?: { [key: string]: string } }
  } | null,
  localeProperties: any,
) {
  if (!product || !product.extensions?.novuSeoUrls) {
    return `/products/${product?.id || ''}`
  }

  const { shopwareLangId } = localeProperties || {} // Fallback if localeProperties is undefined
  const seoUrls = product.extensions.novuSeoUrls || {}
  return seoUrls[shopwareLangId] || `/products/${product.id}`
}
